import axios from '@/store/config';
import * as config from '@/config';

export default {
  state : {

    // dropdowns m.m. data från API som tidigare legat i config.js
    config : {
      neighbourhoods:[],
      sortOptions: [],
      rentalObjectTypes: [],
      vehicleSpaceTypes: [],
      rentAmounts:[],
      rentAmountsOther:[],
      otherAreas: [],
      apartmentArea:[],
      roomAmount:[],
      messageOption:[],
      areas: [],
      accesses:[],
      pets:[],
      parkingsWaitingListTypes:[],
      premisesWaitingListTypes:[]
    },
  },

  // getters
  getters : {
    config : state => {
      return state.config
    },
    webapp_config: state => {
      var ret = null;
      if(!!window.gavlegardarna && !!window.gavlegardarna.webapp_config) {
        ret = gavlegardarna.webapp_config;
      }
      return ret;
    }
  },

  actions : {

    async getConfig({ commit }) {
      try {
        // Commit initial config
        commit('setConfig', { config });

        // Fetch all data in parallel using async/await with Promise.all
        const [getVehicals, getRentals, getWaitingListTypes] = await Promise.all([
          axios.get('lists/vehicleSpaceTypes'),
          axios.get('lists/rentalObjectTypes'),
          axios.get('lists/waitingListTypes')
        ]);

        // Commit the data to Vuex store
        commit('setRentalObjectTypes', getRentals.data);
        commit('setVehicleSpaceTypes', getVehicals.data);

        // Process and transform waiting list types
        const waitingListTypes = {
          parking: getWaitingListTypes.data.parking.map((type) => ({
            value: type,
            label: type.replace(/,.+/, '')
          })),
          premises: getWaitingListTypes.data.premises.map((type) => ({
            value: type,
            label: type.replace(/,.+/, '')
          })),
          student: getWaitingListTypes.data.student.map((type) => ({
            value: type,
            label: type.replace(/,.+/, '')
          }))
        };

        // Commit transformed waiting list types to Vuex store
        commit('setWaitingListTypes', waitingListTypes);

        // Return true to indicate success
        return true;
      } catch (err) {
        // Handle any errors and log them
        console.error('Error fetching configuration data:', err);
        throw err; // This will be caught by the caller if needed
      }
    }

  },

  mutations : {
    setConfig(state, data) {
       state.config.accesses = data.config.accesses;
       state.config.areas = data.config.areas;
       state.config.rentAmounts = data.config.rentAmounts;
       state.config.rentAmountsOther = data.config.rentAmountsOther;
       state.config.apartmentArea = data.config.apartmentArea;
       state.config.otherArea = data.config.otherArea;
       state.config.messageOption = data.config.messageOption;
       state.config.neighbourhoods = data.config.neighbourhoods;
       state.config.neighbourhoodsStudent = data.config.neighbourhoodsStudent;
       state.config.sortOptions = data.config.sortOptions;
       state.config.roomAmount = data.config.roomAmount;
       state.config.pets = data.config.pets;
    },

    setRentalObjectTypes(state, data){
      state.config.rentalObjectTypes = data;
    },
    setVehicleSpaceTypes(state, data) {
      state.config.vehicleSpaceTypes = data;
    },
    setWaitingListTypes(state, data) {
      state.config.parkingsWaitingListTypes = data.parking;
      state.config.premisesWaitingListTypes = data.premises;
    }
  }
}
